import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DELETE_DEVICE } from './url-constants';

type DeleteDeviceEndpointSpecification = ApiEndpointSpecification;
export const DeleteDeviceEndpointSpecification: DeleteDeviceEndpointSpecification = {
    url: DELETE_DEVICE,
    method: HttpMethod.DELETE,
    requestParamsSchemaName: 'DeleteDeviceRequestParams',
    requestBodySchemaName: 'DeleteDeviceRequestBody',
    okResponseSchemaName: 'DeleteDeviceOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:2.0
};

export const invokeDeleteDevice = Helpers.makeApiRequestFn<
    Types.DeleteDeviceRequestParams,
    Types.DeleteDeviceRequestBody,
    Types.DeleteDeviceOkResponse
>(DeleteDeviceEndpointSpecification);
